export const getHistoricalFPLs = async () => {
  const historical = await fetch('parsedFpl.js', {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
  return await historical.json()
}
